import cx from 'classnames';
import type { ReactNode } from 'react';

import styles from './MarkdownStyles.module.scss';

export const MarkdownStyles = ({ children, classNames }: { children: ReactNode; classNames?: string }) => {
	return <div className={cx(styles.markdown, classNames)}>{children}</div>;
};
